import { render, staticRenderFns } from "./NoOrders.vue?vue&type=template&id=6162c4df&"
import script from "./NoOrders.vue?vue&type=script&lang=js&"
export * from "./NoOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports